export const colors = {
	primary: "#FEC04D",
	darkBlue: "#090740",
	success: "#23A455",
	light: "#F8F8F8",
	dark: "#212529",
	secondary: "#777777",
	danger: "red",
	white: "#ffffff",
	darkBlack: "#212529"
}
